import React from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import {Routes,Route,BrowserRouter} from 'react-router-dom';
import Home from './components/Home';
import ClinicReputation from './components/reputation/ClinicReputation';
import WelcomePage from './components/patientforms/WelcomePage';

import UnsubscribePage from './components/patientforms/UnsubscribePage';
import SmsConfirmation from './components/sms-gateway/confirmation/SmsConfirmation';
import LinkExpired from './components/link-expired/LinkExpired';
import WelcomeFormPage from './components/patientforms_new/WelcomeFormPage';
import ThankyouPage from './components/patientforms_new/ThankyouPage';
import ContactLensReorderPage from './components/patientforms_new/ContactLensReorderPage';
import Appointments from './components/patientforms_new/Appointments';
import ArticlePage from './components/patientforms_new/Articles'; 
import CommPrefs from './components/patientforms_new/CommPrefs';
import PickupConfirm from './components/patientforms_new/PickupConfirm';
import AppointmentCancel from './components/patientforms_new/AppointmentCancel';
import AppointmentBooking from './components/patientforms_new/AppointmentBooking';
function App() {
  return (
    <>
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="r">
                <Route path=":clinicId" element={<ClinicReputation/>}/>  
              </Route> 
              <Route path="p">
                <Route path=":clinicId">    
                      <Route path="wc" element={<WelcomePage/>}/>  
                    
                      <Route path="unsubscribe" element={<UnsubscribePage/>}/>
                       <Route path="ra" element={<WelcomePage/>}/>  
                </Route>
              </Route> 
              <Route path="clinics">
                <Route path=":clinicId">
                  <Route path="welcome">
                    <Route path=":patientId" element={<WelcomeFormPage/>} />
                  </Route>
                  <Route path="comm-pref">
                    <Route path=":patientId" element={<CommPrefs/>} />
                  </Route>
                  <Route path="thankyou">
                    <Route path=":patientId" element={<ThankyouPage/>} />
                  </Route>
                  <Route path="contact-lens">
                    <Route path=":patientId" element={<ContactLensReorderPage/>} />
                  </Route>
                  <Route path="appointments" element={<Appointments/>} >
                  </Route>

                  <Route path="appointment-cancel" element={<AppointmentCancel/>} />
                  <Route path="appointment-booking" element={<AppointmentBooking/>} />
                  <Route path="article">
                    <Route path=":articleId" element={<ArticlePage/>} />
                  </Route>

                  <Route path="pickup-confirm">
                    <Route path=":patientId" element={<PickupConfirm/>} />
                  </Route>
                </Route>
              </Route>
              <Route path="sms-gateway">
                <Route path="clinic">
                  <Route path=":clinicId">
                    <Route path="confirmation">
                      <Route path=":messageId" element={<SmsConfirmation/>} />
                    </Route>
                  </Route>
                </Route>
              </Route>
              <Route path="link-expired" element={<LinkExpired/>}></Route>
          </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;